import React, { useEffect, useRef, useState } from 'react'
import { css } from '@emotion/core'
import useEventListener from '../../../shared/hooks/useEventListener'

const fillCols = (children, cols) => {
  if (children && cols.length > 0) {
    children.forEach((child, i) => cols[i % cols.length].push(child))
  }
}

// Masonry view with CSS Grid - Special Thanks to Janosh Riebesell
// https://janosh.dev/blog/react-hooks-masonry
export default function Masonry({ children, gap, minWidth = 500, columnCount, ...rest }) {
  const ref = useRef()
  const [numCols, setNumCols] = useState(columnCount)
  const cols = [...Array(numCols)].map(() => [])
  fillCols(children, cols)

  const masonryContainer = css`
    display: grid;
    grid-template-columns: repeat(${numCols}, 1fr);
    grid-auto-flow: column;
    grid-gap: ${gap};
  `

  const masonryColumn = css`
    display: grid;
    align-content: start;
    grid-gap: ${gap};
  `

  const resizeHandler = () => {
    if (ref?.current?.offsetWidth) {
      setNumCols(Math.ceil(ref.current.offsetWidth / minWidth))
    }
  }
  useEffect(resizeHandler, [])
  useEventListener(`resize`, resizeHandler)

  return (
    <div css={masonryContainer} ref={ref} gap={gap} {...rest}>
      {cols.map((colGroups) => (
        <div css={masonryColumn} key={colGroups[0]?.key}>
          {colGroups}
        </div>
      ))}
    </div>
  )
}
